import { fixturesDefaultLayout } from "./fixtures/layouts/default/main";
import { leagueDetailDefaultLayout } from "./league-detail/layouts/default/main";
import { leagueStandingsDefaultLayout } from "./league-standings/layouts/default/main";
import { livescoreCompactLayout } from "./livescore/layouts/compact/main";
import { livescoreDefaultLayout } from "./livescore/layouts/default/main";
import { matchDetailDefaultLayout } from "./match-detail/layouts/default/main";
import { oddsDefaultLayout } from "./odds/layouts/default/main";
import { oddsBoardDefaultLayout } from "./odds-board/layouts/default/main";
import { resultsDefaultLayout } from "./results/layouts/default/main";
import { teamDetailDefaultLayout } from "./team-detail/layouts/default/main";
import { createLayoutRegistry } from "../shared/layouts/registry";

export const layoutRegistry = createLayoutRegistry([
  livescoreDefaultLayout,
  livescoreCompactLayout,
  fixturesDefaultLayout,
  resultsDefaultLayout,
  oddsDefaultLayout,
  oddsBoardDefaultLayout,
  matchDetailDefaultLayout,
  leagueDetailDefaultLayout,
  leagueStandingsDefaultLayout,
  teamDetailDefaultLayout,
]);
